<!--
 * @Author: scg
 * @Date: 2022-01-17 16:18:42
 * @LastEditTime: 2022-02-24 11:04:05
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="page_title">
      {{$t('select.title')}}
    </div>
    <div class="Take">
      {{$t('select.tips1')}}
    </div>
    <div class="Manufacturer_ul">
      <div
        class="Manufacturer"
        @click="getsystem(key, val)"
        v-for="(val, key) in list"
        :key="key"
      >
        <img v-if="isshow == key" src="@/assets/img/qdui.png" alt="" />
        <img v-if="isshow != key" src="@/assets/img/qnodui.png" alt="" />
        {{ val.system }}
      </div>
    </div>
    <div class="Select">
      <div>{{ list[isshow].name }}</div>
      <p v-html="list[isshow].des"></p>
      <!-- <div>What version of Android OS is installed on the target device?</div>
    <p>1.What version of Android OS is installed on the target device?</p>
    <p>2.What version of Android OS is installed on the target device?</p>
    <p>3.What version of Android OS is installed on the target device?</p>
    <p>4.What version of Android OS is installed on the target device?</p>
    <a>View the operation process</a> -->
    </div>

    <video autoplay v-if="video_url" :src="video_url" class="Select_img" controls></video>
    <!-- <img src="https://p.ssl.qhimg.com/t017efc9aa407b6bb9f.png" alt="" class="Select_img"> -->
    <div class="twoButton">
      <div @click="$router.push({ name: 'Manufacturer' })" class="BackButton">
        {{$t('select.back')}}
      </div>
      <div @click="goDisable()" class="loginButton">{{$t('select.continue')}}</div>
    </div>
  </div>
</template>

<script>
import { BindDeviceGetSystemList } from '@/api/user'

export default {
  name: 'HelloWorld',
  data () {
    return {
      list: [],
      video_url: '',
      isshow: 0,
      msg: ''
    }
  },
  mounted () {
    console.log(this.$route.params)
    BindDeviceGetSystemList().then((adj) => {
      console.log(adj.data)
      this.list = adj.data
      this.video_url = adj.data[0].video_url
    })
  },
  methods: {
    getsystem (key, val) {
      this.isshow === key ? (this.isshow = 0) : (this.isshow = key)
      this.video_url = val.video_url
    },
    goDisable () {
      this.$router.push({
        name: 'Disable',
        params: {
          device_brand: this.$route.params.device_brand,
          id: this.$route.params.id,
          system: this.list[this.isshow].id
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  background: #fff;
  overflow: hidden;
}
.Take {
  font-size: 14px;
  color: grey;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
}
.Manufacturer {
  width: 290px;
  height: 60px;
  line-height: 60px;
  margin-right: 20px;
  margin-bottom: 20px;
  float: left;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  font-size: 14px;
  color: #000927;
  cursor: pointer;
}
.Manufacturer img {
  float: left;
  width: 20px;
  height: 20px;
  margin: 20px 15px 0 20px;
}
.Manufacturer_ul {
  overflow: hidden;
  margin-left: 5%;
  margin-top: 40px;
  width: 650px;
}
.Select {
  width: 602px;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  margin-left: 5%;
  font-size: 13px;
}
.Select div {
  color: #000927;
  width: 552px;
  margin-left: 25px;
  line-height: 40px;
  margin-top: 10px;
  font-size:14px;
}
.Select p {
  line-height: 30px;
  color: grey;
  width: 552px;
  margin-left: 25px;
}
.Select a {
  margin-top: 8px;
  display: block;
  width: 100%;
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #e1e3e6;
  color: #0080ff;
}
.Select_img {
  position: absolute;
  left: 740px;
  top: 160px;
  width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/Select.vue